<template>
  <div class="Settlement">
    <div class="page-title">{{ title }}</div>
    <ATable
      :data="items"
      :loading="loading"
      :summaryTitleColumnIndex="0"
      :summaryFields="summaryFields"
      :summaryMethod="summaryMethod"
      :row-class-name="rowClassName"
      show-summary
      hide-button-insert
      hide-pagination
      border
    >
      <div slot="search">
        <div class="inline">
          <AMonthSelector
            v-model="period"
          />
        </div>
        <div class="inline ml-default">
          <el-button
            type="primary"
            size="mini"
            round
            v-shortkey="['f5']"
            @shortkey.native="handleClickSearch"
            @click="handleClickSearch"
          >검색(F5)</el-button>
        </div>
      </div>
      <el-table-column 
        label="계정" 
        prop="name"
      />
      <el-table-column 
        label="금액" 
        prop="price"
        class-name="cell-number"
        :formatter="util.numberFormat"
      />
      <el-table-column 
        label="매출대비"         
        class-name="cell-number"
        :formatter="resolvePercentage"
      />
    </ATable>
  </div>
</template>
<script>
export default {
  data() {
    return {
      title: this.$t('title.settlement'),
      period: undefined,
      loading_sale: false,
      loading_inbound: false,
      loading_asset: false,
      loading_earnings: false,
      loading_misc: false,
      items_sale: [],
      items_inbound: [],
      items_asset: [],
      items_earnings: [],
      items_misc: [],
      sum_sale: 0,
      summaryFields: ['price'],
      sale_items: [
        'goods','goods_dc','goods_type1','goods_type2','service',
        'glass','touch','w_touch','sensor','safety_sensor', 'etc'
      ],
      inbound_items: ['customer1', 'etc'],
    }
  },
  computed: {
    loading() {
      return this.loading_sale || this.loading_inbound || this.loading_asset || this.loading_earnings || this.loading_misc;
    },
    items() {
      if (this.loading) { return []; }
      if (this.items_sale.length < 1) { return []; }
      // 1.매출금액
      let stat = this.items_sale[0];
      let items = [];
      let item = { id: 'sale', name: '1.매출금액', price: this.sum_sale, children: []};
      items.push(item);
      // 기계
      stat.goods = stat.goods_sum - (stat.goods_type1 + stat.goods_type2);
      // 기타매출
      stat.etc = stat.total_sum - (stat.goods_sum + stat.safety_sensor + stat.sensor + stat.service + stat.touch + stat.w_touch);
      this.sale_items.forEach(key => {
        item.children.push({ 
          id: 'sale_' + key, 
          name: this.resolveSaleName(key), 
          price: stat[key]
        });
      });
      // 2.매입금액
      stat = this.items_inbound[0];
      item = { id: 'inbound', name: '2.매입금액', price: stat.total_sum, children: []};
      items.push(item);
      stat.customer1 = stat.customer1? stat.customer1: 0;
      stat.etc = stat.total_sum - stat.customer1;
      this.inbound_items.forEach(key => {
        item.children.push({ 
          id: 'inbound_' + key, 
          name: this.resolveInboundName(key), 
          price: stat[key]
        });
      });
      // 3.급여
      items.push(this.makeAssetStat('salary'));
      // 4.판매비와 관리비
      items.push(this.makeAssetStat('management'));
      // 5.카드대금
      items.push(this.makeAssetStat('card'));
      // 6.세금
      items.push(this.makeAssetStat('tax'));
      // 7.영업이익
      let total = items[0].price;
      for (let i=1; i<items.length; i++) {
        total -= items[i].price;
      }
      item = { id: 'income', name: '7.영업이익', price: total, children: []};
      items.push(item);
      // 8.영업외수익
      item = this.makeEarningStat();
      total += item.price
      items.push(item);
      // 9.영업외비용
      item = this.makeMiscStat();
      total -= item.price
      items.push(item);
      // 10.당기순이익
      item = { id: 'profit', name: '10.당기순이익', price: total, children: []};
      items.push(item);
      return items;
    },
  },
  methods: {
    loadData() {
      this.loading_sale = true;
      this.loading_inbound = true;
      this.loading_asset = true;
      this.loading_earnings = true;
      this.loading_misc = true;
      this.items_sale = [];
      this.items_inbound = [];
      this.items_asset = [];
      this.items_earnings = [];
      this.items_misc = [];
      this.sum_sale = 0;
      this.api.statSaleSettlement(this.period).then(res => {
        if (res.error !== this.system.noError) {
          this.loading_sale = false;
          return;
        }
        this.items_sale = res.data;
        this.sum_sale = this.items_sale[0]['total_sum'];
        this.loading_sale = false;
      });
      this.api.statInboundSettlement(this.period).then(res => {
        if (res.error !== this.system.noError) {
          this.loading_inbound = false;
          return;
        }
        this.items_inbound = res.data;
        this.loading_inbound = false;
      });
      this.api.statAssetSettlement(this.period).then(res => {
        if (res.error !== this.system.noError) {
          this.loading_asset = false;
          return;
        }
        this.items_asset = res.data;
        this.loading_asset = false;
      });
      this.api.statAssetEarningsSettlement(this.period).then(res => {
        if (res.error !== this.system.noError) {
          this.loading_earnings = false;
          return;
        }
        this.items_earnings = res.data;
        this.loading_earnings = false;
      });
      this.api.statAssetMiscSettlement(this.period).then(res => {
        if (res.error !== this.system.noError) {
          this.loading_misc = false;
          return;
        }
        this.items_misc = res.data;
        this.loading_misc = false;
      });
    },
    makeAssetStat(key) {
      let stat = this.items_asset.filter(a => a.type_name === key);
      let price = 0;
      stat.forEach(s => {
        price += s.total;
      })
      let item = { id: key, name: this.resolveAssetName(key), price: price, children: []};
      stat.forEach(s => {
        item.children.push({ 
          id: `${key}_${s.category_id}`, 
          name: s.name, 
          price: s.total
        });
      })
      return item;
    },
    makeEarningStat() {
      let key = 'earnings'
      let stat = this.items_earnings;
      let price = 0;
      stat.forEach(s => {
        price += s.total;
      })
      let item = { id: key, name: this.resolveAssetName(key), price: price, children: []};
      stat.forEach(s => {
        item.children.push({ 
          id: `${key}_${s.category_id}`, 
          name: s.name, 
          price: s.total
        });
      })
      return item;
    },
    makeMiscStat() {
      let key = 'misc'
      let stat = this.items_misc;
      let price = 0;
      stat.forEach(s => {
        price += s.total;
      })
      let item = { id: key, name: this.resolveAssetName(key), price: price, children: []};
      stat.forEach(s => {
        item.children.push({ 
          id: `${key}_${s.category_id}`, 
          name: s.name, 
          price: s.total
        });
      })
      return item;
    },
    summaryMethod({ columns, data }) {
      if (columns.length < 1) { return []; }
      if (data.length < 1) { return []; }
      let ret = ['합계', this.util.numberWComma(data[data.length - 1].price)];
      return ret;
    },
    resolveSaleName(key) {
      switch(key) {
        case 'etc':
          return '기타매출';
        case 'glass':
          return '유리';
        case 'goods':
          return '기계';
        case 'goods_dc':
          return '기계DC';
        case 'goods_type1':
          return '3연동';
        case 'goods_type2':
          return '원슬라이딩';
        case 'safety_sensor':
          return '안전센서';
        case 'sensor':
          return '센서';
        case 'service':
          return 'A/S및 시공';
        case 'touch':
          return '터치';
        case 'w_touch':
          return '무선터치';
        default:
          return key;
      }
    },
    resolveInboundName(key) {
      switch(key) {
        case 'etc':
          return '매입';
        case 'customer1':
          return '제일안전유리';
        default:
          return key;
      }
    },
    resolveAssetName(key) {
      switch(key) {
        case 'salary':
          return '3.급여';        
        case 'management':
          return '4.판매비와 관리비';
        case 'card':
          return '5.카드대금';
        case 'tax':
          return '6.세금';
        case 'earnings':
          return '8.영업외수익';
        case 'misc':
          return '9.영업외비용';
        default:
          return key;
      }
    },
    resolvePercentage(item) {
      if (item.id.startsWith('sale') || item.id.startsWith('earnings')) { return ''; }
      if (!item.price) { return '0.0%'; }
      return (item.price / this.sum_sale * 100).toFixed(1) + '%';
    },
    handleClickSearch() {
      this.loadData();
    },
    rowClassName({row}) {
      return (row.id.indexOf('_') < 0)? 'represent_row': '';
    },
  },
}
</script>
<style lang="scss">
@import "@/assets/css/_variables.scss";

.Settlement {
  .represent_row {
    font-weight: bold;
    color: $color-primary;
  }
}
</style>